<template>
  <div>
    <el-dialog :title="$t('LogoBatchEditLogo') +'/Icon'" :visible.sync="logoData.show" width="500px" center>
      <el-form :model="editForm" label-width="100px">
        <el-form-item :label="$t('AgentID')">
          <el-input type="textarea" :rows="5" v-model="editForm.UserId" :placeholder="$t('EnterAgentIDCommaSeparated')"></el-input>
        </el-form-item>
        <el-form-item label="Icon">
          <el-upload class="avatar-uploader" :action="this.$global.baseURL + '/upload'" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :headers="{ 'x-token': token }">
            <img v-if="imageUr" :src="`${baseurl}${imageUr}`" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="Logo">
          <el-upload class="avatar-uploader" :action="this.$global.baseURL + '/upload'" :show-file-list="false" :on-success="handleAvatarSuccessLogo" :before-upload="beforeAvatarUpload" :headers="{ 'x-token': token }">
            <img v-if="LogoImageUr" :src="`${baseurl}${LogoImageUr}`" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item  :label="$t('Remarks')">
          <el-input type="textarea" :rows="5" v-model="editForm.Remark" :placeholder="$t('EnterRemark')"></el-input>
        </el-form-item>
        <el-form-item  :label="$t('GoogleVerificationCode')">
          <el-input v-model="editForm.GoogleCode"  :placeholder="$t('Remarks')"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click="submitEditRow">{{ $t('Confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    logoData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      editForm: {
        UserId: "",
        Memo: "",
        GoogleCode: "",
      },
      token: sessionStorage.getItem("token"),
      imageUr: "",
      LogoImageUr: "",
      baseurl: JSON.parse(sessionStorage.getItem("userdata")).FileBaseUrl,
    }
  },
  methods: {
    handleAvatarSuccess(file) {
      this.imageUr = file.data.filename
    },
    handleAvatarSuccessLogo(file) {
      this.LogoImageUr = file.data.filename
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type == "image/jpeg" || file.type == "image/png" || file.type == "image/webp"
      const isLt2M = file.size / 1024 / 1024 < 1

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG/webp 格式!")
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 1MB!")
      }
      return isJPG && isLt2M
    },
    submitEditRow() {
      if (!this.editForm.UserId) return this.$message.warning(this.$t('EnterAgentID'))
      if (!this.imageUr) return this.$message.warning("请上传Icon")
      if (!this.LogoImageUr) return this.$message.warning("请上传Logo")
      if (!this.editForm.GoogleCode) return this.$message.warning(this.$t('EnterGoogleVerificationCode'))
      const data = {
        Ids: this.editForm.UserId ? this.editForm.UserId.split(",").map(Number) : [],
        Icon: this.imageUr,
        Logo: this.LogoImageUr,
        Remark: this.editForm.Remark,
        GoogleCode: this.editForm.GoogleCode,
      }
      this.$emit("submitLogoData", data)
    },
  },
}
</script>
<style scoped>
::v-deep .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
  text-align: center;
}

::v-deep .avatar {
  width: 80px !important;
  height: 80px !important;
  display: block;
}

::v-deep .el-upload--text {
  width: 80px !important;
  height: 80px !important;
}
</style>
